import { ConvertStringToHtmlId } from '../../../../../libs/ts/ConvertStringToHtmlId';

export interface props {
  link: string;
  linkText: string;
  openInNewTab?: boolean;
  className?: string;
  textFollowingLink?: string;
}

const newTabIcon = (linkId: string) => {
  return (
    <svg id={`${linkId}`} width="45" height="45" viewBox="0 0 45 45" className={`fill-interactive-coral visited:fill-interactive-coral-db-70 inline-block ml-2 w-4`} xmlns="http://www.w3.org/2000/svg">
      <path d="M 41.470703 4.9863281 A 1.50015 1.50015 0 0 0 41.308594 5 L 27.5 5 A 1.50015 1.50015 0 1 0 27.5 8 L 37.878906 8 L 22.439453 23.439453 A 1.50015 1.50015 0 1 0 24.560547 25.560547 L 40 10.121094 L 40 20.5 A 1.50015 1.50015 0 1 0 43 20.5 L 43 6.6894531 A 1.50015 1.50015 0 0 0 41.470703 4.9863281 z M 12.5 8 C 8.3754991 8 5 11.375499 5 15.5 L 5 35.5 C 5 39.624501 8.3754991 43 12.5 43 L 32.5 43 C 36.624501 43 40 39.624501 40 35.5 L 40 25.5 A 1.50015 1.50015 0 1 0 37 25.5 L 37 35.5 C 37 38.003499 35.003499 40 32.5 40 L 12.5 40 C 9.9965009 40 8 38.003499 8 35.5 L 8 15.5 C 8 12.996501 9.9965009 11 12.5 11 L 22.5 11 A 1.50015 1.50015 0 1 0 22.5 8 L 12.5 8 z"></path>
    </svg>
  );
};

export const ExternalLink = (props: props) => {
  if (props.openInNewTab === true) {
    return (
      <div className={`pb-7 ${props.className}`}>
        <span>
          <a
            className={`jbp-link-${ConvertStringToHtmlId(props.linkText)} pb-1 font-bold border-b-[2px] text-interactive-coral hover:text-solid-bold-green hover:border-solid-bold-green visited:text-interactive-coral-db-70`}
            href={`${props.link}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {props.linkText}
          </a>{' '}
          {newTabIcon(`jbp-link-${ConvertStringToHtmlId(props.linkText)}`)} {props.textFollowingLink}
        </span>
      </div>
    );
  }
  return (
    <div className={`pb-7 ${props.className}`}>
      <span>
        <a
          className={`jbp-link-${ConvertStringToHtmlId(props.linkText)} pb-1 font-bold border-b-[2px] text-interactive-coral hover:text-solid-bold-green hover:border-solid-bold-green visited:text-interactive-coral-db-70`}
          href={`${props.link}`}
        >
          {props.linkText}
        </a>{' '}
        {props.textFollowingLink}
      </span>
    </div>
  );
};

export const ExternalFooterLink = (props: props) => {
  if (props.openInNewTab === true) {
    return (
      <div className={`pb-2 ${props.className}`}>
        <span>
          <a
            className={`jbp-link-${ConvertStringToHtmlId(props.linkText)} text-white hover:text-solid-bold-green hover:border-solid-bold-green`}
            href={`${props.link}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {props.linkText}
          </a>{' '}
          {newTabIcon(`jbp-link-${ConvertStringToHtmlId(props.linkText)}`)} {props.textFollowingLink}
        </span>
      </div>
    );
  }
  return (
    <div className={`pb-2 ${props.className}`}>
      <span>
        <a className={`jbp-link-${ConvertStringToHtmlId(props.linkText)} text-white hover:text-solid-bold-green hover:border-solid-bold-green`} href={`${props.link}`}>
          {props.linkText}
        </a>{' '}
        {props.textFollowingLink}
      </span>
    </div>
  );
};
